export default "__VITE_ASSET__2f20b051__"